module.exports = __webpack_public_path__ + "img/hondaridgeline.4a0211d3.png";